/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * email_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Machine-readable failure category for calendar mutations.
 */
export type CalendarMutationErrorCode =
  (typeof CalendarMutationErrorCode)[keyof typeof CalendarMutationErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CalendarMutationErrorCode = {
  not_found: 'not_found',
  occurrence_not_found: 'occurrence_not_found',
  read_only: 'read_only',
  no_writable_calendar: 'no_writable_calendar',
  not_attendee: 'not_attendee',
  invalid_input: 'invalid_input',
  reauth_required: 'reauth_required',
  provider_rejected: 'provider_rejected',
  retryable: 'retryable',
  persist_failed: 'persist_failed',
} as const;
